export * from "./DeliveryPageContent";
